/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface ExceptionResponseError
 */
export interface ExceptionResponseError {

    /**
     * @type {any}
     * @memberof ExceptionResponseError
     */
    target?: any;

    /**
     * @type {string}
     * @memberof ExceptionResponseError
     */
    property?: string;

    /**
     * @type {any}
     * @memberof ExceptionResponseError
     */
    value?: any;

    /**
     * @type {any}
     * @memberof ExceptionResponseError
     */
    constraints: any;

    /**
     * @type {Array<string>}
     * @memberof ExceptionResponseError
     */
    children?: Array<string>;

    /**
     * @type {any}
     * @memberof ExceptionResponseError
     */
    contexts?: any;
}
